
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-6'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메인화면 관리 - 인스타그램 {{ $route.query.instagram_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.instagram_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='instagram_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'instagram_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.instagramTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.instagramTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='instagram_link'>링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'instagram_link'
                maxLength="200"
                placeholder = "링크를 입력해 주세요."
                v-model="formData.instagramLink"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.instagramLinkError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='instagram_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="instagram_status"
                v-model="formData.instagramStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='instagram_main_status'>메인 노출<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="instagram_main_status"
                v-model="formData.instagramMainStatus"
              >
                <option value='1'>노출</option>
                <option value='2'>미노출</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">메인 노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1080 x 1080px</p>
                <label for='instagram_main_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.instagram_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'instagram_main_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_Square">
                  <img
                    :src="formData.instagramMainImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.instagramMainImageURL"
                    alt="PC용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.instagramMainImageURLError}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_instagram_one,
  insert_instagram,
  update_instagram
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminInstagramManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner
  },
  setup () {
    return {
      formData: ref({
        instagramTitle: '',
        instagramLink: '',
        instagramStatus: 1,
        instagramMainStatus: 2,
        instagramMainImage: '',
        instagramMainImageURL: ''
      }),
      errorData: ref({
        instagramTitleError: '',
        instagramLinkError: '',
        instagramMainImageURLError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.instagramMainImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.instagramMainImageURL = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.instagramTitle === '') {
        this.errorData.instagramTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.instagramTitleError = ''
      }
      if (this.formData.instagramLink === '') {
        this.errorData.instagramLinkError = '링크를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.instagramLinkError = ''
      }
      if (this.formData.instagramMainImageURL === '') {
        this.errorData.instagramMainImageURLError = '메인 노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.instagramMainImageURLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.instagram_ID === undefined) {
          insert_instagram(
            this.formData.instagramTitle,
            this.formData.instagramLink,
            this.formData.instagramMainImage,
            this.formData.instagramStatus,
            this.formData.instagramMainStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminInstagramManagement'
          })
        } else {
          update_instagram(
            this.$route.query.instagram_ID,
            this.formData.instagramTitle,
            this.formData.instagramLink,
            this.formData.instagramMainImage,
            this.formData.instagramStatus,
            this.formData.instagramMainStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminInstagramManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.instagram_ID !== undefined) {
      get_instagram_one(this.$route.query.instagram_ID).then((result) => {
        this.formData.instagramTitle = result[0].instagram_title
        this.formData.instagramLink = result[0].instagram_link
        this.formData.instagramStatus = result[0].instagram_status
        this.formData.instagramMainStatus = result[0].instagram_main_status
        this.formData.instagramMainImageURL = result[0].instagram_main_image
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminInstagramManagementAdd.vue